import React from 'react';

interface SupportIconProps {
  className?: string;
  title?: string;
}

const SupportIcon: React.FC<SupportIconProps> = ({ className = "w-4 h-4", title }) => {
  return (
    <>
      {/* Light mode - Light support icon */}
      <img
        src="/images/support-light-icon.png"
        alt="Support"
        className={`${className} dark:hidden`}
        title={title}
      />
      {/* Dark mode - Original support icon */}
      <img
        src="/images/support-icon.png"
        alt="Support"
        className={`${className} hidden dark:block`}
        title={title}
      />
    </>
  );
};

export default SupportIcon;

